var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Breadcrumb, Button, Card, Collapse, Select, Table, Typography, Space, Alert, message } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getRegulatoryInfoReact, getCompareVerRegulatoryInfo } from '../../services/regulationService';
import { FolderOutlined, InfoCircleOutlined, RadiusUpleftOutlined, SafetyCertificateOutlined, SettingOutlined } from '@ant-design/icons';
import certificateService from '../../services/certificateService';
import { useSelector } from 'react-redux';
import { decodeBase64, formatDateDisplay, getCountryCombination } from '../../utils/commonUtil';
import '../../styles/style.css';
import WatermarkComponent from '../../components/common/watermark';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
const RegulationInfoCompare = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const [objRegulatoryInfoLower, setObjRegulatoryInfoLower] = useState(null);
    const [objRegulatoryInfoHigher, setObjRegulatoryInfoHigher] = useState(null);
    const [intCompareFromRegVer, setIntCompareFromRegVer] = useState(0);
    const [intCompareToRegVer, setIntCompareToRegVer] = useState(0);
    const [intCompareFromVersion, setIntCompareFromVersion] = useState(null);
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [compareVersionManual, setCompareVersionManual] = useState(false);
    const { regUniqueId } = useParams();
    const [messageApi, contextHolder] = message.useMessage();
    const applicationData = useSelector((state) => state.applicationData);
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 4)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        else if ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId) {
            commonService
                .logUserActivity((_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.strUserEmailId, UserActivity.CP__Requirement_Summ_Detail_Visited);
        }
    }, []);
    useEffect(() => {
        setCompareVersionManual(false);
        fetchRegulatoryData();
    }, [regUniqueId]);
    useEffect(() => {
        if (compareVersionManual) {
            fetchRegulatoryData();
        }
    }, [compareVersionManual]);
    const fetchRegulatoryData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!regUniqueId)
            return;
        try {
            setLoading(true);
            const decodedText = decodeBase64(regUniqueId);
            const splitText = decodedText.split('-');
            const compareToVersion = parseInt(splitText[1], 10);
            let toVersion = 0;
            let fromVersion = 0;
            const objRegDetailsInfo = {
                strRegulationId: splitText[0],
                intCompanyID: (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
                intVersion: compareToVersion,
                lstLuCompany: [{
                        intId: (_d = (_c = applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID
                    }]
            };
            if (!compareVersionManual) {
                setIntCompareToRegVer(compareToVersion);
                toVersion = compareToVersion;
            }
            else {
                toVersion = intCompareToRegVer;
                objRegDetailsInfo.intVersion = intCompareToRegVer || 0;
            }
            const lowerRegInfo = yield getCompareVerRegulatoryInfo(objRegDetailsInfo);
            setObjRegulatoryInfoLower(lowerRegInfo);
            if ((intCompareFromRegVer === null || intCompareFromRegVer === 0) &&
                compareToVersion != null &&
                (lowerRegInfo === null || lowerRegInfo === void 0 ? void 0 : lowerRegInfo.lstValidRegVersion.length) > 0) {
                let foundVersion = 0;
                for (const version of lowerRegInfo === null || lowerRegInfo === void 0 ? void 0 : lowerRegInfo.lstValidRegVersion) {
                    if (compareToVersion !== version && intCompareFromVersion < version) {
                        foundVersion = version;
                    }
                }
                if (foundVersion === 0) {
                    for (const version of lowerRegInfo === null || lowerRegInfo === void 0 ? void 0 : lowerRegInfo.lstValidRegVersion) {
                        if (version > intCompareFromVersion && version < compareToVersion) {
                            foundVersion = version;
                        }
                    }
                }
                setIntCompareFromVersion(foundVersion);
                setIntCompareFromRegVer(foundVersion);
                objRegDetailsInfo.intVersion = foundVersion;
                fromVersion = foundVersion;
            }
            else {
                objRegDetailsInfo.intVersion = intCompareFromRegVer || 0;
                fromVersion = intCompareFromRegVer;
            }
            const higherRegInfo = yield getRegulatoryInfoReact(objRegDetailsInfo);
            setObjRegulatoryInfoHigher(getCountryCombination(higherRegInfo, (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _e === void 0 ? void 0 : _e.lstobjAccessScreenCombination, applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails));
            if (higherRegInfo && lowerRegInfo) {
                const intHigherVer = higherRegInfo.intVersion;
                const intLowerVer = lowerRegInfo.intVersion;
                const mapHashKeyVsHigherFreqBand = new Map();
                if (higherRegInfo.lstRegulatedFreqBands) {
                    for (const objHigherFreqBand of higherRegInfo.lstRegulatedFreqBands) {
                        objHigherFreqBand.strApplicability = `V${intHigherVer}`;
                        const hashCode = generateHashCode(objHigherFreqBand);
                        mapHashKeyVsHigherFreqBand.set(hashCode, objHigherFreqBand);
                    }
                }
                if (lowerRegInfo.lstRegulatedFreqBands) {
                    for (const objLowerFreqBand of lowerRegInfo.lstRegulatedFreqBands) {
                        const hashCode = generateHashCode(objLowerFreqBand);
                        if (mapHashKeyVsHigherFreqBand.has(hashCode)) {
                            const higherBand = mapHashKeyVsHigherFreqBand.get(hashCode);
                            higherBand.strApplicability = `V${intLowerVer}, V${intHigherVer}`;
                            objLowerFreqBand.strApplicability = `V${intLowerVer}, V${intHigherVer}`;
                        }
                        else {
                            objLowerFreqBand.strApplicability = `V${intLowerVer}`;
                            objLowerFreqBand.strApplicability = `V${intLowerVer}`;
                            higherRegInfo.lstRegulatedFreqBands.push(objLowerFreqBand);
                        }
                    }
                }
            }
            if (((_f = lowerRegInfo === null || lowerRegInfo === void 0 ? void 0 : lowerRegInfo.lstValidRegVersion) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                const menuItems = lowerRegInfo.lstValidRegVersion.map((version) => ({
                    label: `V${version}`,
                    value: version.toString()
                }));
                setOptions(menuItems);
            }
            if (toVersion && fromVersion && toVersion > fromVersion) {
                setObjRegulatoryInfoHigher(getCountryCombination(Object.assign(Object.assign({}, lowerRegInfo), { boolCheckProcedureDetailsEmpty: lowerRegInfo.boolCheckProcedureDetailsEmpty, boolIsCountryCombination: true, boolCheckLabelInfoDetailsEmpty: lowerRegInfo.boolCheckLabelInfoDetailsEmpty, boolCertInfoDetailsEmpty: lowerRegInfo.boolCertInfoDetailsEmpty, lstStandardRegulationDetails: lowerRegInfo.lstStandardRegulationDetails, lstRegulatedFreqBands: lowerRegInfo.lstRegulatedFreqBands }), (_g = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _g === void 0 ? void 0 : _g.lstobjAccessScreenCombination, applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails));
                setObjRegulatoryInfoLower(higherRegInfo);
            }
        }
        catch (error) {
            console.error('Error fetching regulatory data:', error);
        }
        finally {
            setLoading(false);
            setCompareVersionManual(false);
        }
    });
    const handleRegByVerAndCompare = () => {
        if (intCompareFromRegVer === intCompareToRegVer) {
            messageApi.open({
                type: 'error',
                content: 'Selected versions should not be same',
            });
        }
        else {
            setCompareVersionManual(true);
        }
    };
    const generateHashCode = (obj) => {
        const str = `${obj.property1}_${obj.property2}_${obj.property3}`;
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash;
        }
        return hash.toString();
    };
    const getItems = () => {
        var _a;
        return [
            {
                key: '1',
                label: _jsxs(Space, { children: [_jsx(FolderOutlined, {}), _jsx(Typography.Text, { strong: true, children: "General Regulatory Information" })] }),
                children: (_jsx(_Fragment, { children: ((_a = applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolRequirementSummaryDetailsPageGeneralInformation) && (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolIsCountryCombination) ? (_jsx(Table, { columns: columns, dataSource: dataSourceGenInfo, pagination: false, loading: loading, bordered: true })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this \n              information.Kindly reach out to BV contact for same.", type: "info", showIcon: true })) })),
            },
            {
                key: '2',
                label: _jsxs(Space, { children: [_jsx(SettingOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Procedure" })] }),
                children: (_jsx(_Fragment, { children: !(objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolCheckProcedureDetailsEmpty) ? ((objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolIsCountryCombination) ? (_jsx(Table, { columns: columns, dataSource: dataSourceProcedure, pagination: false, loading: loading, bordered: true })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this \n              information.Kindly reach out to BV contact for same.", type: "info", showIcon: true }))) : ('') })),
            },
            {
                key: '3',
                label: _jsxs(Space, { children: [_jsx(InfoCircleOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Labeling Information" })] }),
                children: (_jsx(_Fragment, { children: !(objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolCheckLabelInfoDetailsEmpty) ? ((objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolIsCountryCombination) ? (_jsx(Table, { columns: columns, dataSource: dataSourceLabelInfo, pagination: false, loading: loading, bordered: true })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this \n              information.Kindly reach out to BV contact for same.", type: "info", showIcon: true }))) : ('') })),
            },
            {
                key: '4',
                label: _jsxs(Space, { children: [_jsx(SafetyCertificateOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Certificate Information" })] }),
                children: (_jsx(_Fragment, { children: !(objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolCertInfoDetailsEmpty) ? ((objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolIsCountryCombination) ? (_jsxs(_Fragment, { children: [_jsx("div", { style: { overflowX: 'auto' }, children: _jsx(Table, { columns: columns, dataSource: dataSourceCertInfo, pagination: false, loading: loading, scroll: { x: 'max-content' }, bordered: true }) }), _jsx("style", { children: `
              @media (max-width: 767px) {
                .ant-table-wrapper {
                  overflow-x: auto;
                }
              }
            ` })] })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this \n              information.Kindly reach out to BV contact for same.", type: "info", showIcon: true }))) : ('') })),
            },
            {
                key: '5',
                label: _jsxs(Space, { children: [_jsx(RadiusUpleftOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Standards & Regulations" })] }),
                children: (_jsx(_Fragment, { children: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.lstRegulatedFreqBands) ? ((objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.boolIsCountryCombination) ? (_jsx(Table, { dataSource: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.lstRegulatedFreqBands, columns: regFreqBandsColumns, pagination: false, loading: loading })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this \n              information.Kindly reach out to BV contact for same.", type: "info", showIcon: true }))) : ('') })),
            }
        ];
    };
    const DownloadDoc = (strDocRefId) => {
        if (!strDocRefId) {
            console.error('Document reference ID is undefined.');
            return;
        }
        certificateService
            .getFileDocument(strDocRefId)
            .then((res) => {
            if (!res || !res.bytefileData || !res.strDocName) {
                console.error('Invalid response from certificateService.getFileDocument');
                return;
            }
            const docName = res.strDocName;
            const bytefileData = new Uint8Array(res.bytefileData);
            let mimeType = 'application/*'; // Default MIME type
            if (docName.endsWith('.pdf')) {
                mimeType = 'application/pdf';
            }
            else if (docName.endsWith('.zip')) {
                mimeType = 'application/zip';
            }
            else if (docName.endsWith('.jpg') || docName.endsWith('.jpeg')) {
                mimeType = 'image/jpeg';
            }
            else if (docName.endsWith('.png')) {
                mimeType = 'image/png';
            } // Add more MIME types as needed
            const blob = new Blob([bytefileData], { type: mimeType });
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = docName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            // Cleanup the object URL after the download
            URL.revokeObjectURL(downloadUrl);
        })
            .catch((error) => {
            console.error('Error downloading the document:', error);
        });
    };
    const columns = [
        {
            title: (_jsx(Typography.Text, { children: "Version" })),
            dataIndex: 'ver',
            key: 'ver',
            align: 'left',
            width: '20%',
            render: (text) => _jsx(Typography.Text, { children: text })
        },
        {
            title: (_jsx(Typography.Text, { children: `V${intCompareToRegVer > intCompareFromRegVer ? intCompareFromRegVer : intCompareToRegVer}` })),
            dataIndex: 'v1',
            key: 'v1',
            align: 'left',
            width: '40%'
        },
        {
            title: (_jsx(Typography.Text, { children: `V${intCompareToRegVer > intCompareFromRegVer ? intCompareToRegVer : intCompareFromRegVer}` })),
            dataIndex: 'v2',
            key: 'v2',
            align: 'left',
            width: '40%',
            render: (text, record) => (_jsx(Typography.Text, { mark: text !== record.v1, children: text }))
        }
    ];
    const dataSourceGenInfo = [
        {
            key: '1',
            ver: _jsx(Typography.Text, { strong: true, children: "Regulatory Name" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strRegulatorName,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strRegulatorName
        },
        {
            key: '2',
            ver: _jsx(Typography.Text, { strong: true, children: "Technology/Product Regulated" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strTechProdRegulated,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strTechProdRegulated
        },
        {
            key: '3',
            ver: _jsx(Typography.Text, { strong: true, children: "Mandatory Voluntary" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strMandVoluntary,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strMandVoluntary
        },
        {
            key: '4',
            ver: _jsx(Typography.Text, { strong: true, children: "Application/License Holder Requirements" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strApplLicenseHolderReq,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strApplLicenseHolderReq
        },
        {
            key: '5',
            ver: _jsx(Typography.Text, { strong: true, children: "Test sample No./Condition" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strTestSampleNoCondition,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strTestSampleNoCondition
        },
        {
            key: '6',
            ver: _jsx(Typography.Text, { strong: true, children: "Lead time" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strLeadTime,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strLeadTime
        },
        {
            key: '7',
            ver: _jsx(Typography.Text, { strong: true, children: "Certification Body (if any)" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strCertBody,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strCertBody
        },
        {
            key: '8',
            ver: _jsx(Typography.Text, { strong: true, children: "Test in-country/ CB Acceptance" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strTestInCountryCBAccept,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strTestInCountryCBAccept
        },
        {
            key: '9',
            ver: _jsx(Typography.Text, { strong: true, children: "Lab Accreditation Requirements" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strLabAccredReq,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strLabAccredReq
        },
        {
            key: '10',
            ver: _jsx(Typography.Text, { strong: true, children: "Approval is Needed for?" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strNeedApproval,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strNeedApproval
        },
        {
            key: '11',
            ver: _jsx(Typography.Text, { strong: true, children: "Product Marking Requirement" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strProductMarkingReq,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strProductMarkingReq
        },
        {
            key: '12',
            ver: _jsx(Typography.Text, { strong: true, children: "Factory Inspection" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strFactoryInspection,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strFactoryInspection
        },
        {
            key: '13',
            ver: _jsx(Typography.Text, { strong: true, children: "Preshipment inspection/Market Surveillance" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strPreshipmentInspecMarketSurveil,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strPreshipmentInspecMarketSurveil
        },
        {
            key: '14',
            ver: _jsx(Typography.Text, { strong: true, children: "Effective Date" }),
            v1: formatDateDisplay(objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.dtValidFrom),
            v2: formatDateDisplay(objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.dtValidFrom)
        },
        {
            key: '15',
            ver: _jsx(Typography.Text, { strong: true, children: "Repealed Date" }),
            v1: formatDateDisplay(objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.dtValidTo),
            v2: formatDateDisplay(objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.dtValidTo)
        }
    ];
    const dataSourceProcedure = [
        {
            key: '1',
            ver: _jsx(Typography.Text, { strong: true, children: "Procedure Details" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strProcedureDetails,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strProcedureDetails
        },
        {
            key: '2',
            ver: _jsx(Typography.Text, { strong: true, children: "Modular Approval" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strModularApproval,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strModularApproval
        },
        {
            key: '3',
            ver: _jsx(Typography.Text, { strong: true, children: "MRA Program (if any)" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strMRAProgram,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strMRAProgram
        }
    ];
    const dataSourceLabelInfo = [
        {
            key: '1',
            ver: _jsx(Typography.Text, { strong: true, children: "Mandatory Logo / Marking on product" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strMandLogoMarkingProduct,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strMandLogoMarkingProduct
        },
        {
            key: '2',
            ver: _jsx(Typography.Text, { strong: true, children: "Logo / Marking" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strLogoMarking,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strLogoMarking
        },
        {
            key: '3',
            ver: _jsx(Typography.Text, { strong: true, children: "Label size, color, font requirement" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strLabelColorSizeFontReq,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strLabelColorSizeFontReq
        },
        {
            key: '4',
            ver: _jsx(Typography.Text, { strong: true, children: "Labeling rules" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strLabelingRules,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strLabelingRules
        },
        {
            key: '5',
            ver: _jsx(Typography.Text, { strong: true, children: "e-labeling" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strELabeling,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strELabeling
        },
        {
            key: '6',
            ver: _jsx(Typography.Text, { strong: true, children: "Certificate Sample" }),
            v1: (_jsx("a", { href: "#", onClick: (e) => {
                    var _a;
                    e.preventDefault();
                    DownloadDoc((_a = objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.objLabelSample) === null || _a === void 0 ? void 0 : _a.strDocName);
                }, children: (_e = objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.objLabelSample) === null || _e === void 0 ? void 0 : _e.strDocName })),
            v2: (_jsx("a", { href: "#", onClick: (e) => {
                    var _a;
                    e.preventDefault();
                    DownloadDoc((_a = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objLabelSample) === null || _a === void 0 ? void 0 : _a.strDocName);
                }, children: (_f = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objLabelSample) === null || _f === void 0 ? void 0 : _f.strDocName }))
        },
        {
            key: '7',
            ver: _jsx(Typography.Text, { strong: true, children: "Mandatory Statement on User's manual" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strMandStatementUserManual,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strMandStatementUserManual
        },
        {
            key: '8',
            ver: _jsx(Typography.Text, { strong: true, children: "Marking requirement if product is too small" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strMarkReqProductSmall,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strMarkReqProductSmall
        },
        {
            key: '9',
            ver: _jsx(Typography.Text, { strong: true, children: "User's manual / label - Language on Application" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strUserManualLabelLangAppl,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strUserManualLabelLangAppl
        },
        {
            key: '10',
            ver: _jsx(Typography.Text, { strong: true, children: "User's manual / label - Language on Importation" }),
            v1: objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strUserManualLabelLangImport,
            v2: objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strUserManualLabelLangImport
        }
    ];
    const dataSourceCertInfo = [
        {
            key: '1',
            ver: _jsx(Typography.Text, { strong: true, children: "Certificate Validity period; renewable?" }),
            v1: (objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strCertValidityYearMonth) || '',
            v2: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strCertValidityYearMonth) || ''
        },
        {
            key: '2',
            ver: _jsx(Typography.Text, { strong: true, children: "Variant/series/family models on certificate" }),
            v1: (objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strVariantSeriesFamilyModelCert) || '',
            v2: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strVariantSeriesFamilyModelCert) || ''
        },
        {
            key: '3',
            ver: _jsx(Typography.Text, { strong: true, children: "Re-certification (new/extension, year/month)" }),
            v1: (objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strReCertification) || '',
            v2: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strReCertification) || ''
        },
        {
            key: '4',
            ver: _jsx(Typography.Text, { strong: true, children: "Multiple brand/trade mark on certificate" }),
            v1: (objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strMultipleBrandTradeCert) || '',
            v2: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strMultipleBrandTradeCert) || ''
        },
        {
            key: '5',
            ver: _jsx(Typography.Text, { strong: true, children: "Changes on issued Certificate" }),
            v1: (objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strChangeIssueCerificate) || '',
            v2: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strChangeIssueCerificate) || ''
        },
        {
            key: '6',
            ver: _jsx(Typography.Text, { strong: true, children: "Procedure on changed certificates" }),
            v1: (objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strProcedureChangedCert) || '',
            v2: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strProcedureChangedCert) || ''
        },
        {
            key: '7',
            ver: _jsx(Typography.Text, { strong: true, children: "Certificate Sample" }),
            v1: (_jsx("a", { href: "#", onClick: (e) => {
                    var _a;
                    e.preventDefault();
                    DownloadDoc((_a = objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.objCertificateSample) === null || _a === void 0 ? void 0 : _a.strDocName);
                }, children: (_g = objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.objCertificateSample) === null || _g === void 0 ? void 0 : _g.strDocName })),
            v2: (_jsx("a", { href: "#", onClick: (e) => {
                    var _a;
                    e.preventDefault();
                    DownloadDoc((_a = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objCertificateSample) === null || _a === void 0 ? void 0 : _a.strDocName);
                }, children: (_h = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objCertificateSample) === null || _h === void 0 ? void 0 : _h.strDocName }))
        },
        {
            key: '8',
            ver: _jsx(Typography.Text, { strong: true, children: "Track Issued Certificate on Website" }),
            v1: (objRegulatoryInfoLower === null || objRegulatoryInfoLower === void 0 ? void 0 : objRegulatoryInfoLower.strTrackIssuedCertOnWebsite) || '',
            v2: (objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.strTrackIssuedCertOnWebsite) || ''
        }
    ];
    const regFreqBandsColumns = [
        {
            title: 'Application type',
            dataIndex: 'appltype',
            key: 'appltype',
            render: (text, record) => { var _a; return _jsx(Typography.Text, { children: (_a = record.objRegApplicationType) === null || _a === void 0 ? void 0 : _a.strLongDesc }); }
        },
        {
            title: 'Frequency Bands',
            dataIndex: 'freqbands',
            key: 'freqbands',
            render: (text, record) => _jsx(Typography.Text, { children: record.strFreqBands })
        },
        {
            title: 'Max Strength/RF output power',
            dataIndex: 'maxstrength',
            key: 'maxstrength',
            render: (text, record) => (_jsx(Typography.Text, { children: record.strMaxStrengthRFOutputPower }))
        },
        {
            title: 'Max Bandwidth',
            dataIndex: 'maxbandwidth',
            key: 'maxbandwidth',
            render: (text, record) => _jsx(Typography.Text, { children: record.strMaxBandwidth })
        },
        {
            title: 'Harmonized Standard Reference',
            dataIndex: 'harmonizedref',
            key: 'harmonizedref',
            render: (text, record) => (_jsx(Typography.Text, { children: record.strHarmonizedStandRef }))
        },
        {
            title: (_jsx("div", { dangerouslySetInnerHTML: {
                    __html: 'Remarks (Emission type,<br/>duty cycle,<br/>other restrictions)'
                } })),
            dataIndex: 'remarks',
            key: 'remarks',
            render: (text, record) => (_jsx("div", { dangerouslySetInnerHTML: { __html: record.strRemarks || '' } }))
        },
        {
            title: 'Applicability',
            width: 80,
            dataIndex: 'strApplicability',
            key: 'strApplicability',
            render: (text, record) => text
        }
    ];
    return (_jsxs(Card, { title: 'Requirement Summary', extra: _jsxs(Space, { children: [_jsx(Typography.Text, { children: "Compare Between" }), _jsx(Select, { value: (intCompareToRegVer === null || intCompareToRegVer === void 0 ? void 0 : intCompareToRegVer.toString()) || '...', onChange: (value) => setIntCompareToRegVer(Number(value)), options: options }), _jsx(Select, { value: (intCompareFromRegVer === null || intCompareFromRegVer === void 0 ? void 0 : intCompareFromRegVer.toString()) || '...', onChange: (value) => setIntCompareFromRegVer(Number(value)), options: options }), _jsx(Button, { onClick: handleRegByVerAndCompare, type: "primary", children: "View" })] }), children: [contextHolder, _jsx(Breadcrumb, { style: { marginBottom: '10px' }, items: [
                    {
                        title: _jsx(Typography.Text, { children: (_j = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objLuCountry) === null || _j === void 0 ? void 0 : _j.strLongDesc })
                    },
                    {
                        title: _jsx(Typography.Text, { children: (_k = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objLuServiceCode) === null || _k === void 0 ? void 0 : _k.strLongDesc })
                    },
                    {
                        title: _jsx(Typography.Text, { children: ((_l = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objLuProductType) === null || _l === void 0 ? void 0 : _l.strLongDesc) != null
                                ? (_m = objRegulatoryInfoHigher === null || objRegulatoryInfoHigher === void 0 ? void 0 : objRegulatoryInfoHigher.objLuProductType) === null || _m === void 0 ? void 0 : _m.strLongDesc
                                : 'All Products' })
                    }
                ] }), _jsx(WatermarkComponent, { children: _jsx(Collapse, { bordered: false, defaultActiveKey: ['1', '2', '3', '4', '5', '6'], items: getItems() }) })] }));
};
export default RegulationInfoCompare;
